import {makeObservable, observable} from "mobx";
import {Api} from "modules/utils/Api";
import {ApiModel} from "modules/stores/Base/ApiModel";
import {IApiResponse} from "modules/types";
import {RequestState} from "modules/enums";

interface IUser {
	id: number;
	email: string;
	firstName: string;
	lastName: string;
	favoriteTeam: number;
	username: string;
	lang: string;
	country: string;
	locationCode: null;
	termsGZ: boolean;
	optInGZ: boolean;
	ageOptIn: boolean;
	avatar: null;
	isNotificationsEnabled: boolean;
	createdAt: Date;
}

type TResponse = {
	user: IUser;
};

export class User extends ApiModel<IApiResponse<TResponse>> {
	@observable public isLogged: boolean = false;
	@observable private user: IUser | null = null;
	@observable public optInGZ: boolean = false;

	constructor() {
		super(Api.User.get);
		makeObservable(this);
	}

	protected performResponse(resp: IApiResponse<TResponse>): void {
		this.user = resp.success.user;
	}

	get id() {
		return this.user?.id;
	}

	get email() {
		return this.user?.email;
	}

	get isLoggedIn() {
		return !!this.user?.id && this.apiState === RequestState.Received;
	}

	get favoriteTeam() {
		return this.user?.favoriteTeam;
	}
}
